// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mx-1";
export var spinner = "_mx-0";